import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArER: CultureInfo = {
  name: 'ar-ER',
  displayName: 'العربية (إريتريا)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-ER',
  parent: CultureInfoAr
};
